import MuiStepper, { type StepperProps as MuiStepperProps } from '@mui/material/Stepper';
import type { FC } from 'react';

export const BaseStepper: FC<MuiStepperProps> = (props) => <MuiStepper {...props} />;
